import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'firebaseApiKey',
  initialState: null as null | string,
  reducers: {
    setFirebaseApiKey(state,  action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setFirebaseApiKey } = slice.actions;

export default slice.reducer;
